import { render, staticRenderFns } from "./EmpresaContacto.vue?vue&type=template&id=147ba2ce"
import script from "./EmpresaContacto.vue?vue&type=script&lang=js"
export * from "./EmpresaContacto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports